import * as actions from "@/AppRedux/actions/admin/hotelProfileConfig/hotelProfileConfigType"
import { HotelProfileResponse } from "@/AppRedux/actions/admin/hotelProfileConfig/hotelProfileConfigType"

export type ProcessTypes = {
  status: boolean
  action: "HOTEL_PROFILE_CONTENT_REQUEST" | "HOTEL_PROFILE_CONTENT_UPDATE" | "HOTEL_PROFILE_GOOGLE_MAP_UPDATE" | "HOTEL_PROFILE_GALLERY_UPDATE" | null
  message?: string | null
}

export type HotelProfileConfigState = {
  process: ProcessTypes
  dataSource: HotelProfileResponse | null
  loading: boolean
}

const initialState: HotelProfileConfigState = {
  process: {
    status: false,
    action: null,
    message: null,
  },
  loading: false,
  dataSource: null,
}

const hotelProfileConfigReducer = (
  state: HotelProfileConfigState = initialState,
  action: actions.HotelProfileConfigAction,
): HotelProfileConfigState => {
  switch (action.type) {
    case actions.HOTEL_PROFILE_CONTENT_REQUEST:
      return {
        ...state,
        loading: true,
        process: initialState.process,
      }
    case actions.HOTEL_PROFILE_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        process: {
          status: true,
          action: "HOTEL_PROFILE_CONTENT_REQUEST",
          message: "Content loaded successfully",
        },
        dataSource: action.payload,
      }
    case actions.HOTEL_PROFILE_CONTENT_FAILED:
      return {
        ...state,
        loading: false,
        process: {
          status: false,
          action: "HOTEL_PROFILE_CONTENT_REQUEST",
          message: action.payload,
        },
        dataSource: null,
      }
    case actions.HOTEL_PROFILE_CONTENT_UPDATE_BATCH_REQUEST:
      return {
        ...state,
        loading: true,
        process: initialState.process,
      }
    case actions.HOTEL_PROFILE_CONTENT_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        process: {
          status: true,
          action: "HOTEL_PROFILE_CONTENT_UPDATE",
          message: "Updated successfully",
        },
      }
    case actions.HOTEL_PROFILE_CONTENT_UPDATE_FAILURE:
      return {
        ...state,
        loading: false,
        process: {
          status: false,
          action: "HOTEL_PROFILE_CONTENT_UPDATE",
          message: action.payload,
        },
      }
    case actions.HOTEL_PROFILE_GOOGLE_MAP_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        process: {
          status: true,
          action: "HOTEL_PROFILE_GOOGLE_MAP_UPDATE",
          message: "Google Map settings updated successfully",
        },
      }
    case actions.HOTEL_PROFILE_GOOGLE_MAP_UPDATE_FAILURE:
      return {
        ...state,
        loading: false,
        process: {
          status: false,
          action: "HOTEL_PROFILE_GOOGLE_MAP_UPDATE",
          message: action.payload,
        },
      }
    case actions.HOTEL_PROFILE_GALLERY_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        process: {
          status: true,
          action: "HOTEL_PROFILE_GALLERY_UPDATE",
          message: "Gallery updated successfully",
        },
      }
    case actions.HOTEL_PROFILE_GALLERY_UPDATE_FAILURE:
      return {
        ...state,
        loading: false,
        process: {
          status: false,
          action: "HOTEL_PROFILE_GALLERY_UPDATE",
          message: action.payload,
        },
      }
    case actions.HOTEL_PROFILE_PROCESS_CLEAR:
      return {
        ...state,
        process: initialState.process,
      }
    default:
      return state
  }
}

export default hotelProfileConfigReducer
